import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { TInfoDadosPropriedade } from './InfoDadosPropriedade';
import moment from 'moment';

export default function DialogInfoDadosPropriedade({
    open,
    onClose,
    dadosPropriedade
}: DialogInfoDadosPropriedadeProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Detalhes propriedade</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 4 }}>
                        <Typography variant='caption'><b>Nome:</b> {dadosPropriedade.nome}</Typography>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <Typography variant='caption'><b>Própria:</b> {dadosPropriedade.propriaProp}</Typography>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <Typography variant='caption'><b>Tamanho(Ha):</b> {dadosPropriedade.tamanho}</Typography>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <Typography variant='caption'><b>Arrendatário/Comodatário:</b> {dadosPropriedade.arrendatario}</Typography>
                    </Grid>
                    <Grid  size={{ xs:8 }}>
                        <Typography variant='caption'><b>Vencimento do contrato:</b> {dadosPropriedade.arrendatario  === "Sim" ? moment(dadosPropriedade.vencimentoContrato).format("DD/MM/YYYY") : '-'}</Typography>
                    </Grid>
                    <Grid  size={{ xs:3 }}>
                        <Typography variant='caption'><b>Produtor de leite?</b> {dadosPropriedade.leite.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Média diária:</b> {dadosPropriedade.leite.mediaDiaria || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. vacas:</b> {dadosPropriedade.leite.qtdVacas || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.leite.valor !== '' ? `${dadosPropriedade.leite.valor}` : "R$-"}</Typography>
                    </Grid>

                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Produtor de café?</b> {dadosPropriedade.cafe.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. sacas:</b> {dadosPropriedade.cafe.qtdSacas || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. Ha:</b> {dadosPropriedade.cafe.qtdHa || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.cafe.valor ? `${dadosPropriedade.cafe.valor}` : "R$-"}</Typography>
                    </Grid>

                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Produtor de milho?</b> {dadosPropriedade.milho.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. sacas:</b> {dadosPropriedade.milho.qtdSacas || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. Ha:</b> {dadosPropriedade.milho.qtdHa || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.milho.valor ? `${dadosPropriedade.milho.valor}` : "R$-"}</Typography>
                    </Grid>

                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Produtor de soja?</b> {dadosPropriedade.soja.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. sacas:</b> {dadosPropriedade.soja.qtdSacas || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. Ha:</b> {dadosPropriedade.soja.qtdHa || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.soja.valor ? `${dadosPropriedade.soja.valor}` : "R$-"}</Typography>
                    </Grid>

                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Possui gado corte?</b> {dadosPropriedade.gadoCorte.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qtd. cabeças:</b> {dadosPropriedade.gadoCorte.qtdCabecas || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Raça:</b> {dadosPropriedade.gadoCorte.raca || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.gadoCorte.valor ? `${dadosPropriedade.gadoCorte.valor}` : "R$-"}</Typography>
                    </Grid>

                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Possui outra cultura?</b> {dadosPropriedade.outraCultura.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qual:</b> {dadosPropriedade.outraCultura.nome || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Produção estimada:</b> {dadosPropriedade.outraCultura.producaoEstimada || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.outraCultura.valor ? `${dadosPropriedade.outraCultura.valor}` : "R$-"}</Typography>
                    </Grid>

                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Produtor outra renda?</b> {dadosPropriedade.outraRenda.produtor || "Nao"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Qual:</b> {dadosPropriedade.outraRenda.nome || "-"}</Typography>
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        {/* Empty cell for alignment */}
                    </Grid>
                    <Grid size={{ xs:3 }}>
                        <Typography variant='caption'><b>Valor:</b> {dadosPropriedade.outraRenda.valor ? `${dadosPropriedade.outraRenda.valor}` : "R$-"}</Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Fechar
                </Button>
            </DialogActions>

        </Dialog>
    )
}

interface DialogInfoDadosPropriedadeProps {
    open: boolean;
    onClose: () => void;
    dadosPropriedade: TInfoDadosPropriedade;
}
